import styled from 'styled-components'

const CancelAction = styled.button`
    color: #fff;
    background-color: #e30002;
    border-color: #e30002;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    outline: none;
    &:hover {
        opacity: 0.6;
    }
`

const Container = styled.div`
    background: #fafafa;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
    padding-top: 30px;
`

const Row = styled.div`
    display: flex;
    padding: 6px 20px;

`

const Status = styled.span`
    color: #FFF;
    background: ${props => props.danger ? 'var(--red)' : 'var(--green)'};
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 13px;
`

const StatuFree = styled(Status)`
    background: var(--yellow);
`


const LabelColumn = styled.div`
    min-width: 130px;
    font-weight: 600;
`

const Divider = styled.div`
    margin: 30px 0px;
    background: #ccc;
    height: 1px;
`

const DetailColumn = styled.div`
`

const CancelContainer = styled.div`
    padding: 20px;
    padding-top: 0px;
    user-select: none;
`

const CancelText = styled.span`
    text-decoration: underline;
    cursor: pointer;
`

export {
    CancelAction,
    Container,
    LabelColumn,
    DetailColumn,
    Row,
    Divider,
    CancelContainer,
    CancelText,
    Status,
    StatuFree
}